import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { isSingleSelectServerUserGuest } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { ServerSettingsUnauthenticated } from '../../../settings/services/ServerSettingsUnauthenticated';
import { serverUserForcePasswordUpdate } from '../actions/ServerUserMenuActions';
import { IServerUserInfo } from '../models/IServerUserInfo';

export const ServerUserForcePasswordupdateAction: IEntityAction<IServerUserInfo, {}> = {
  name: EntityActionNames.ServerUserForcePasswordReset,
  translateName: Messages.forcePasswordUpdate_action,
  isVisible: (_targetItems: IServerUserInfo[], _state: AppState) => {
    return FeatureFlags.localAuthPasswordExpirationEnabled && ServerSettingsUnauthenticated.isServerDomainFamilyLocal();
  },
  isClickable: (_availableActions: {}, targetItems: IServerUserInfo[], _state: AppState) => {
    return targetItems.length > 0 && !isSingleSelectServerUserGuest(targetItems);
  },
  createReduxAction: (targetItems: IServerUserInfo[]) => serverUserForcePasswordUpdate(targetItems)
};
